/**
 * Черновик нового урока.
 *
 * API создаёт урок только вместе с материалами (`materials` — обязательный
 * непустой массив), поэтому до первого сохранения урок живёт на фронте:
 * учитель задаёт название, набирает материалы в параграфе и по «Сохранить»
 * уходит один POST. Черновик не переживает перезагрузку страницы.
 *
 * Название обязательно и заполняется учителем вручную, поэтому черновик
 * может существовать с пустым названием — отсюда отдельный флаг `isActive`.
 */
export const useLessonDraftStore = defineStore('lessonDraft', {
  state: () => ({
    isActive: false,
    title: '',
  }),

  actions: {
    startDraft() {
      this.isActive = true;
      this.title = '';
    },

    setTitle(title) {
      this.title = title;
    },

    clearDraft() {
      this.isActive = false;
      this.title = '';
    },
  },

  getters: {
    hasDraft: (state) => state.isActive,

    // без названия дальнейшие шаги (выбор учебника, сохранение) закрыты
    hasTitle: (state) => !!state.title.trim(),
  },
});
